import FilterRowViewModel from './FilterRowViewModel';
import _ from 'lodash';
import { action, computed, observable, makeObservable } from 'mobx';
import {calendarDate} from 'shared/tools';
import DateInequalityFilterRow from 'main/stores/reports/DateInequalityFilterRow';

class DateFilterRowViewModel extends FilterRowViewModel {
  mapItem;

  operatorOpen = false;
  dateOpen = false;

  constructor({define}) {
    super(define);

    makeObservable(this, {
      operatorOpen: observable,
      dateOpen: observable,
      closeDropdowns: action,
      openOperator: action,
      closeOperator: action,
      openDate: action,
      closeDate: action,
      updateDate: action,
      updateDateRange: action,
      operatorView: action,
      isRangeOperator: computed,
      dateView: computed,
      dateRangeView: computed
    });
  }

  createRow(row) {
    return new DateInequalityFilterRow(row);
  }

  closeDropdowns() {
    this.closeOperator();
    this.closeDate();
  }

  openOperator() {
    this.closeDate();
    this.operatorOpen = true;
  }

  closeOperator() {
    this.operatorOpen = false;
    this.resetRow();
  }

  openDate() {
    this.closeOperator();
    this.dateOpen = true;
  }

  closeDate() {
    this.dateOpen = false;
    this.resetRow();
  }

  updateDate(date) {
    if (!_.get(this.row, 'value')) {
      this.row.updateValue(date);
    }

    this.editingRow.updateValue(date);
  }

  updateDateRange(startDate, endDate) {
    if (!_.get(this.row.range, 'lower_bound')) {
      this.row.range = {
        lower_bound: startDate,
        upper_bound: endDate
      };
    }

    this.editingRow.range = {
      lower_bound: startDate,
      upper_bound: endDate
    };
  }

  operatorView(operator) {
    switch (operator) {
      case '<=':
        return 'before';
      case '>=':
        return 'after';
      default:
        return 'between';
    }
  }

  get isRangeOperator() {
    return this.editingRow.operator === 'between';
  }

  get dateView() {
    return [calendarDate(this.editingRow.value)];
  }

  get dateRangeView() {
    return [
      calendarDate(this.editingRow.range.lower_bound),
      calendarDate(this.editingRow.range.upper_bound)
    ];
  }
}

export default DateFilterRowViewModel;
